import React, { FC } from 'react'
import classNames from 'classnames'
import { t } from '@lingui/macro'

import CircleProgress from '../../../../../components/common/circle-progress/CircleProgress'
import { WorkbookStatusEnum } from '../../../../../graphql/private/PrivateSchemaTypes'
import { TopicEnrolmentQuery } from '../../WorkbooksDetail.codegen'

import './EnrolmentProgressDetail.less'

interface IProps {
  enrolment: NonNullable<
    NonNullable<TopicEnrolmentQuery['analytics']>['workbooks']
  >['topicEnrolment']
}

const EnrolmentProgressDetail: FC<IProps> = ({ enrolment }: IProps) => {
  if (!enrolment) {
    return null
  }
  const progressClasses = classNames('EnrolmentProgress', {
    EnrolmentProgress__notstarted:
      enrolment.status === WorkbookStatusEnum.NOT_STARTED,
    EnrolmentProgress__inprogress:
      enrolment.status === WorkbookStatusEnum.IN_PROGRESS,
    EnrolmentProgress__completed:
      enrolment.status === WorkbookStatusEnum.COMPLETED,
    EnrolmentProgress__failed:
      enrolment.status === WorkbookStatusEnum.OVERDUE ||
      enrolment.status === WorkbookStatusEnum.FAILED
  })

  let lineColor = '#00BB77'
  const stateName = () => {
    switch (enrolment.status) {
      case WorkbookStatusEnum.COMPLETED:
        return t`Resource complete`
      case WorkbookStatusEnum.IN_PROGRESS:
        lineColor = '#5592e2'
        return t`In progress`
      case WorkbookStatusEnum.NOT_STARTED:
        return t`Not started`
      case WorkbookStatusEnum.OVERDUE:
        lineColor = '#EF6969'
        return t`Overdue`
      case WorkbookStatusEnum.FAILED:
        lineColor = '#EF6969'
        return t`Failed`
    }
  }

  return (
    <div className={progressClasses}>
      <div className="EnrolmentProgress__text">
        <h3>{stateName()}</h3>
      </div>
      <CircleProgress
        progress={(enrolment.progress || 0) / 100}
        lineWidth={8}
        lineColor={lineColor}
        backgroundLineColor="#e3e8e9"
        failed={enrolment.status === WorkbookStatusEnum.FAILED}
        completed={enrolment.status === WorkbookStatusEnum.COMPLETED}
      >
        <b>
          {enrolment.progress ? Math.round(enrolment.progress) : 0}
          <em>%</em>
        </b>
      </CircleProgress>
    </div>
  )
}

export default EnrolmentProgressDetail
